module.exports = __webpack_public_path__ + "Roboto-Condensed-Bold.fef3f1f9cc516f436432.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Condensed-Bold.ttf
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Condensed-Bold.ttf
// module chunks = styles